import React from "react";
import { Box, Typography } from "@mui/material";

export default function TVFMLoader() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#C8A054",
        color: "black",
        gap: 2,
      }}
    >
      <Box
        className="loader"
        sx={{
          position: "relative",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          transform: "rotateZ(45deg)",
          perspective: "1000px",
          "&::before, &::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "inherit",
            height: "inherit",
            borderRadius: "50%",
            transform: "rotateX(70deg)",
            animation: "spin 1s linear infinite",
            boxShadow: ".2em 0px 0 0px currentcolor",
          },
          "&::after": {
            color: "black",
            transform: "rotateY(70deg)",
            animationDelay: ".4s",
          },
          color: "black",
          "@keyframes spin": {
            "0%, 100%": { boxShadow: ".2em 0px 0 0px currentcolor" },
            "12%": { boxShadow: ".2em .2em 0 0 currentcolor" },
            "25%": { boxShadow: "0 .2em 0 0px currentcolor" },
            "37%": { boxShadow: "-.2em .2em 0 0 currentcolor" },
            "50%": { boxShadow: "-.2em 0 0 0 currentcolor" },
            "62%": { boxShadow: "-.2em -.2em 0 0 currentcolor" },
            "75%": { boxShadow: "0px -.2em 0 0 currentcolor" },
            "87%": { boxShadow: ".2em -.2em 0 0 currentcolor" },
          },
        }}
      />

      {/* Text Below Loader */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          letterSpacing: "3px",
          color: "black",
          mt: 2,
          fontFamily: "Arial, sans-serif",
        }}
      >
        Glam Company
      </Typography>
    </Box>
  );
}
